import React from 'react';

const RestoreMailButton = ({ teller }) => {
  // Nếu không có dữ liệu, dùng ◯◯
  const getValue = (val) => val || '◯◯';

  const subject = '占い師アカウント復帰のリクエスト';
  const to = 'support@stella-app.com';
  const body = `復帰したい理由や経緯など
ありましたらご自由にご記入ください：

----------
アカウント名 ：${getValue(teller.accountName)}
氏名 ：${getValue(teller.realName)}
メールアドレス：${getValue(teller.email)}
登録日 ：${getValue(teller.registerTime)}
最終ログイン：${getValue(teller.lastLoginTime)}
`;

  const handleClick = () => {
    const mailto = `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(to)}&su=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    window.open(mailto, '_blank', 'noopener,noreferrer');
  };

  return (
    <span onClick={handleClick} style={{ color: ' #d78aa4', cursor: 'pointer', textDecoration: 'underline' }}>
      こちら
    </span>
  );
};

export default RestoreMailButton;